var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 78,
    viewBox: "0 0 74 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2167_26655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.029541 13.0574L36.1068 0.203125L73.1557 12.8288L67.1568 60.5608L36.1068 77.7569L5.54259 60.7893L0.029541 13.0574Z",
    fill: "#E23237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1558 12.8288L36.1069 0.203125V77.7569L67.157 60.5894L73.1558 12.8288Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1639 9.25781L13.6836 59.275L22.0815 59.1322L26.5949 47.8489H46.7616L51.7034 59.275L59.73 59.4178L36.1639 9.25781ZM36.2213 25.2828L43.8194 41.1647H29.5368L36.2213 25.2828Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2167_26655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.4136,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.7b196293621ea479346d4b578e14a5dc.svg";
export { ForwardRef as ReactComponent };